import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';

import { AuthService } from '../../services/auth.service';
import { CandidateService } from '../../services/candidate.service';
import { CompanyService } from '../../services/company.service';

import { ICandidateDetail } from '../../models/ICandidateDetail.model';
import { ICompanyContact } from '../../models/ICompanyContact.model';
import { User } from '../../models/User.model';

@Component({
  templateUrl: './candidate-detail.component.html',
  styleUrls: ['./candidate-detail.component.less']
})
export class CandidateDetailComponent implements OnInit {
  private user: User;

  candidateId: number;
  jobAppId: number;
  candidate: ICandidateDetail;
  resumeImage: string;
  resumeFilePath: string;
  contact: ICompanyContact = null;

  isRequestingInterview = false;
  isDismissingCandidate = false;
  loading = true;

  constructor(
    private _auth: AuthService,
    private _candidate: CandidateService,
    private _company: CompanyService,
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  private getContactInfo(companyContactId: number): void {
    let contactRequest;

    if (this._auth.getImpersonationData()) {
        contactRequest = this._company
            .recruiterGetContact(companyContactId);
    } else {
        contactRequest = this._company.getContact(companyContactId);
    }
    contactRequest
          .subscribe(contact => {
            this.contact = contact;
          });
  }

  ngOnInit() {
    this.user = this._auth.getUser();

    this._route.params.subscribe(params => {
      this.jobAppId = +params['jobAppId'];
      this.candidateId = +params['candidateId'];
      this._candidate
        .getResumeImage(this.candidateId, this.jobAppId, this.user.Id)
        .subscribe(res => {
        this.loading = false;
          this.resumeImage = res.Image;
        });
    });

    this._candidate
      .getCandidate(this.candidateId, this.jobAppId, this.user.Id)
      .subscribe((candidate: ICandidateDetail) => {
        this.candidate = candidate;
        this.candidate.JobAppId = this.jobAppId;
        this.getContactInfo(candidate.CompanyContactId);
      });

  }

  getPdf() {
    const myWindow = window.open('about:blank', 'name', 'height=500,width=550');
    this._candidate.getResumeFile(this.candidateId, this.jobAppId, this.user.Id)
      .subscribe(response => {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        myWindow.location.href = url;
      });
  }

  requestInterview(): void {
    window.scrollTo(0, 0);
    this.isRequestingInterview = true;
  }

  interviewRequestSent(success: boolean): void {
    if (success) {
      this.showInterviewMessage();
      this._router.navigate(['/jobs', this.candidate.JobOrderId], { queryParams: { r: true } });
    }

    this.isRequestingInterview = false;
  }

  showInterviewMessage(): void {
    const alert = document.getElementById('alert-interview');
    alert.classList.add('show');
  }

  dismissCandidate(): void {
    window.scrollTo(0, 0);
    this.isDismissingCandidate = true;
  }

  candidateDismissed(success: boolean): void {
    if (success) {
      this._router.navigate(['/jobs', this.candidate.JobOrderId], { queryParams: { d: true } });
    }

    this.isDismissingCandidate = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidate/candidate-detail.component.ts